import { Type, type Static } from "@sinclair/typebox";
import { PRODUCT_AUTHORIZATION_SCHEMA_VERSION } from "./product-authorization.ts";

const OpaqueIdSchema = Type.String({ minLength: 1, maxLength: 1024 });

export const OpenCloudPermissionRecipientTypeSchema = Type.Union([
  Type.Literal("user"),
  Type.Literal("group")
]);
export type OpenCloudPermissionRecipientType = Static<
  typeof OpenCloudPermissionRecipientTypeSchema
>;

export const OpenCloudPermissionRecipientSchema = Type.Object(
  {
    type: OpenCloudPermissionRecipientTypeSchema,
    objectId: OpaqueIdSchema,
    displayName: Type.Union([Type.String({ minLength: 1, maxLength: 512 }), Type.Null()])
  },
  { additionalProperties: false }
);
export type OpenCloudPermissionRecipient = Static<typeof OpenCloudPermissionRecipientSchema>;

export const OpenCloudPermissionRoleSchema = Type.Object(
  {
    id: OpaqueIdSchema,
    displayName: Type.String({ minLength: 1, maxLength: 256 }),
    description: Type.Union([Type.String({ maxLength: 1024 }), Type.Null()])
  },
  { additionalProperties: false }
);
export type OpenCloudPermissionRole = Static<typeof OpenCloudPermissionRoleSchema>;

export const OpenCloudPermissionSchema = Type.Object(
  {
    schemaVersion: Type.Literal(PRODUCT_AUTHORIZATION_SCHEMA_VERSION),
    permissionId: OpaqueIdSchema,
    roles: Type.Array(OpaqueIdSchema, { minItems: 1, uniqueItems: true }),
    recipient: Type.Union([OpenCloudPermissionRecipientSchema, Type.Null()]),
    inheritedFromResourceId: Type.Union([OpaqueIdSchema, Type.Null()]),
    mutable: Type.Boolean(),
    expiresAt: Type.Union([Type.String({ format: "date-time" }), Type.Null()])
  },
  { additionalProperties: false }
);
export type OpenCloudPermission = Static<typeof OpenCloudPermissionSchema>;

export const OpenCloudPermissionListSchema = Type.Object(
  {
    schemaVersion: Type.Literal(PRODUCT_AUTHORIZATION_SCHEMA_VERSION),
    roles: Type.Array(OpenCloudPermissionRoleSchema, { maxItems: 100 }),
    permissions: Type.Array(OpenCloudPermissionSchema, { maxItems: 10_000 })
  },
  { additionalProperties: false }
);
export type OpenCloudPermissionList = Static<typeof OpenCloudPermissionListSchema>;

export const OpenCloudPermissionGrantInputSchema = Type.Object(
  {
    recipientType: OpenCloudPermissionRecipientTypeSchema,
    recipientId: OpaqueIdSchema,
    roleIds: Type.Array(OpaqueIdSchema, { minItems: 1, maxItems: 16, uniqueItems: true }),
    expiresAt: Type.Optional(Type.String({ format: "date-time" }))
  },
  { additionalProperties: false }
);
export type OpenCloudPermissionGrantInput = Static<typeof OpenCloudPermissionGrantInputSchema>;

export const OpenCloudPermissionUpdateInputSchema = Type.Object(
  { roleIds: Type.Array(OpaqueIdSchema, { minItems: 1, maxItems: 16, uniqueItems: true }) },
  { additionalProperties: false }
);
export type OpenCloudPermissionUpdateInput = Static<typeof OpenCloudPermissionUpdateInputSchema>;
